<template>
  <v-card outlined>
    <v-data-table
      :loading="loading"
      :items="itemsToShow"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :sort-by="['fullName']"
      :sort-desc="[false]"
      :search="filter.search"
      mobile-breakpoint="0"
    >
      <template #[`item.popularity.ranking`]="{ item }">
        <v-select
          v-if="item.popularity"
          v-model="item.popularity.id"
          :items="popularity"
          outlined
          hide-details
          item-value="id"
          item-text="name"
          class="min-width"
          dense
          @change="savePopularity(item)"
        />
      </template>
      <template #[`item.publishedCount`]="{ item }">
        {{ item.publishedCount | separator }}
        <v-tooltip
          bottom
          v-if="item.publishedCount < 10 && !item.isParent"
        >
          <template #activator="{ on, attrs }">
            <v-icon
              small
              v-bind="attrs"
              color="error"
              v-on="on"
              class="ml-2"
            >
              error
            </v-icon>
          </template>
          <span class="px-2"> Need at least 10 templates </span>
        </v-tooltip>
      </template>
      <template #[`item.notPublishedCount`]="{ item }">
        {{ item.notPublishedCount | separator }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          v-if="!parentId"
          class="mr-2"
          outlined
          @click="rowClick(item)"
        >
          Filter
        </v-btn>
        <v-btn :to="`/categories/${item.id}`"> Edit </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogCategories',
  components: {},
  props: { parentId: { type: Number } },
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'fullName' },
        { text: 'Popularity', value: 'popularity.ranking' },
        { text: 'Published', value: 'publishedCount' },
        { text: 'Not Published', value: 'notPublishedCount' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    itemsToShow() {
      let list = this.list;
      if (this.parentId) {
        list = list.filter((x) => x.parentCategory && x.parentCategory.id === this.parentId);
      }
      return list;
    },
    ...mapGetters({
      list: 'categories/list',
      popularity: 'lookup/popularity'
    })
  },
  mounted() {
    this.loading = true;
    Promise.all([this.$store.dispatch('categories/load', this.filter)])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$store.dispatch('catalog/filter', { categoryId: item.id }).then(() => {
        this.$router.push({ path: '/catalog/industries' });
      });
    },
    savePopularity(item) {
      this.saving = true;
      this.$store
        .dispatch('categories/savePopularity', {
          id: item.id,
          popularityId: item.popularity.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Popularity saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
